import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'
import Header from './layout/Header'
import Footer from './layout/Footer'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import joinEasyImage from './join-early.svg'
import playerjpg from './player.jpg'
import appStoreImg from '../../assets/website/images/app-store-image.png'
import googlePlayImg from '../../assets/website/images/google-play-image.png'
import './Home.css'
import * as earlyAccessService from './services/early-access.services'
import * as globalSettingService from '../admin/services/globalsetting.services'
import * as websiteService from './services/website.services'
import * as cmsService from './services/cms.services'
import Swal from 'sweetalert2'
import { handleServerValidations, sanitizeHtml } from '../../utils/commonfunction'
import { SWAL_SETTINGS, FAQ_TYPES, RECAPTCHA_SITE_KEY } from '../../utils/Constants'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';


import bgImg from '../website/bg-img.svg'



const VideoCard = ({ type, src, icon, title, text }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = React.useRef(null);

  const togglePlay = (e) => {
    e.preventDefault();
    if (e.target.closest('.owl-item')?.parentElement?.classList.contains('owl-drag')) return;

    if (type === 'image') return;

    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play().catch(err => console.log("Playback blocked:", err));
      } else {
        videoRef.current.pause();
      }
    }
  };

  const handleFullscreen = (e) => {
    e.stopPropagation();
    if (type === 'image') return; // Might want a lightbox for images later, but just return for now

    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    }
  };

  return (
    <div className='mnetrics_slider_item'>
      <div className='mnetrics-live-card'>
        <div className='mnetrics-live-card-top '>
          <img src={bgImg} alt='bg-img' />
          <div
            className='mnetrics-live-card-visual'
            onClick={togglePlay}
            style={{ cursor: type === 'video' ? 'pointer' : 'default' }}
          >
            {type === 'image' ? (
              <img src={src} alt={title} className='mnetrics-card-video' />
            ) : (
              <>
                <video
                  ref={videoRef}
                  src={src}
                  loop
                  muted
                  playsInline
                  className='mnetrics-card-video'
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                />
                {!isPlaying && (
                  <div className='mnetrics-video-overlay'>
                    <div className='mnetrics-live-card-play'>
                      <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx='22.5' cy='22.5' r='18.75' fill='#ffffff' fillOpacity='0.8' />
                        <path d='M28.0686 19.1814L22.6311 16.0502C21.2811 15.2627 19.6499 15.2627 18.2998 16.0502C16.9498 16.8377 16.1436 18.2252 16.1436 19.8002V26.0814C16.1436 27.6377 16.9498 29.0439 18.2998 29.8314C18.9749 30.2252 19.7249 30.4127 20.4561 30.4127C21.2061 30.4127 21.9374 30.2252 22.6124 29.8314L28.0499 26.7002C29.3999 25.9127 30.2061 24.5252 30.2061 22.9502C30.2436 21.3752 29.4374 19.9689 28.0686 19.1814Z' fill='#008080' />
                      </svg>
                    </div>
                  </div>
                )}
                <button
                  className='mnetrics-fullscreen-btn'
                  onClick={handleFullscreen}
                  aria-label="Full screen"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
                  </svg>
                </button>
              </>
            )}
          </div>
        </div>
        <div className='mnetrics-live-card-copy d-flex flex-column'>
          <div className='mnetrics-icon-box'>
            {icon ? (
              <img src={icon} alt={`${title} icon`} />
            ) : (
              <div className='mnetrics-icon-placeholder'></div>
            )}
          </div>
          <h3 className='mnetrics-live-card-title'>{title}</h3>
          <p className='mnetrics-live-card-text'>{text}</p>
        </div>
      </div>
    </div>
  );
};

function Home() {
  const [activeFaqIndex, setActiveFaqIndex] = useState(0)
  const [globalSettings, setGlobalSettings] = useState(null)
  const [faqs, setFaqs] = useState([])
  const [featureCMS, setFeatureCMS] = useState(null)
  const [heroCMS, setHeroCMS] = useState(null)
  const [chipsCMS, setChipsCMS] = useState(null)
  const [bottomCMS, setBottomCMS] = useState(null)
  const [homePageData, setHomePageData] = useState(null)

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    clubName: '',
    profile: 'Team Manager'
  })

  const [captchaToken, setCaptchaToken] = useState(null)
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Initialize Crisp Chatbot
  // useEffect(() => {
  //   window.$crisp = [];
  //   window.CRISP_WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;
  //   (function() {
  //     let d = document;
  //     let s = d.createElement("script");
  //     s.src = "https://client.crisp.chat/l.js";
  //     s.async = 1;
  //     d.getElementsByTagName("head")[0].appendChild(s);
  //   })();
  // }, []);

  useEffect(() => {
    globalSettingService.Details().then(response => {
      if (response.success) {
        setGlobalSettings(response.data)
      }
    })

    cmsService.FAQ().then(response => {
      if (response.success) {
        const homeFaqs = response.data.filter(f => f.type === FAQ_TYPES.HOME_PAGE);
        setFaqs(homeFaqs);
      }
    })

    websiteService.CMSPage('home_page').then(response => {
      if (response.success && response.data) {
        setHomePageData(response.data)
      }
    })

    websiteService.CMSPage('home_mid_section').then(response => {
      if (response.success) {
        setFeatureCMS(response.data)
      }
    })

  }, [])

  useEffect(() => {
    let $carousel = null
    let isMounted = true

    const initCarousel = async () => {
      window.$ = $
      window.jQuery = $
      await import('owl.carousel/dist/owl.carousel.js')

      if (!isMounted) return

      $carousel = $('.mnetrics-owl-slider')

      if ($carousel.length && typeof $carousel.owlCarousel === 'function') {
        $carousel.owlCarousel({
          loop: false,
          rewind: true,
          margin: 16,
          nav: false,
          dots: false,
          smartSpeed: 550,
          responsive: {
            0: { items: 1 },
            768: { items: 2, margin: 20 },
            1200: { items: 3, margin: 30 },
          },
        })
      }
    }

    initCarousel()

    return () => {
      isMounted = false
      if ($carousel && $carousel.length && typeof $carousel.trigger === 'function') {
        $carousel.trigger('destroy.owl.carousel')
        $carousel.removeClass('owl-loaded owl-drag')
        $carousel.empty()
      }
    }
  }, [globalSettings])

  const handleFaqToggle = (index) => {
    setActiveFaqIndex((prevIndex) => (prevIndex === index ? -1 : index))
  }

  const handlePrevSlide = () => {
    $('.mnetrics-owl-slider').trigger('prev.owl.carousel')
  }

  const handleNextSlide = () => {
    $('.mnetrics-owl-slider').trigger('next.owl.carousel')
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleProfileSelect = (profile) => {
    setFormData(prev => ({ ...prev, profile }))
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault()

    if (!formData.name || !formData.email || !formData.clubName || !formData.profile) {
      Swal.fire({
        icon: 'error',
        text: 'Please fill all required fields',
        ...SWAL_SETTINGS
      })
      return
    }

    if (!executeRecaptcha) {
      Swal.fire({
        icon: 'error',
        text: 'ReCAPTCHA is not yet ready. Please try again in a moment.',
        ...SWAL_SETTINGS
      })
      return
    }

    const token = await executeRecaptcha('early_access_submit');
    if (!token) {
      Swal.fire({
        icon: 'error',
        text: 'Failed to verify ReCAPTCHA. Please refresh and try again.',
        ...SWAL_SETTINGS
      })
      return
    }

    earlyAccessService.Submit({ ...formData, captchaToken: token }).then(response => {
      if (response.success) {
        Swal.fire({
          icon: 'success',
          text: response.message,
          ...SWAL_SETTINGS
        })
        setFormData({
          name: '',
          email: '',
          clubName: '',
          profile: 'Team Manager'
        })
      } else {
        Swal.fire({
          icon: 'error',
          text: handleServerValidations(response),
          ...SWAL_SETTINGS
        })
      }
    }).catch(err => {
      console.error(err)
    })
  }

  const homeSections = homePageData?.sections || [];
  const secTop = homeSections.find(s => s.title === 'Top' || s.title?.toLowerCase() === 'top') || homeSections[0];
  const secMid = homeSections.find(s => s.title === 'mid_2' || s.title?.toLowerCase() === 'mid_2') || homeSections[1];
  const secBottom = homeSections.find(s => s.title === 'Bottom' || s.title?.toLowerCase() === 'bottom') || homeSections[2];

  return (
    <React.Fragment>
      <Header />
      <main>
        <section className='home_banner'>
          <div className='container'>
            <div className='row align-items-center row-gap-md-5 row-gap-4'>
              <div className='col-lg-7'>
                <div className='hero-content'>

                  <div className='hero-copy'>
                    {secTop ? (
                      <>
                        <h1 className='hero-title' style={{ whiteSpace: 'pre-line' }}>
                          {secTop.shortDescription || 'Real Netball Stats. \n Real Performance Insight.'}
                        </h1>
                        <p className='hero-description' style={{ whiteSpace: 'pre-line' }}>
                          {secTop.longDescription || 'mNetrics (pronounced "Netrics", with a silent \'m\'), is the netball performance app for live scores, player and team metrics, performance insights and leaderboards.\n\nAll U14 & U16 National Clubs Finals sign-ups will receive these early access benefits.'}
                        </p>
                      </>
                    ) : heroCMS ? (
                      (() => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(heroCMS.description, 'text/html');
                        const h1 = doc.querySelector('h1');
                        const h1Content = h1 ? h1.innerHTML : '';
                        if (h1) h1.remove();
                        const remainingHtml = doc.body.innerHTML;

                        return (
                          <>
                            {h1Content && (
                              <h1 className='hero-title' dangerouslySetInnerHTML={{ __html: sanitizeHtml(h1Content) }} />
                            )}
                            <div className='hero-description' dangerouslySetInnerHTML={{ __html: sanitizeHtml(remainingHtml) }} />
                          </>
                        );
                      })()
                    ) : (
                      <>
                        <h1 className='hero-title'>Real Netball Stats. <br /> Real Performance Insight.</h1>
                        <p className='hero-description'>
                          {globalSettings?.site_title || 'mNetrics (pronounced "Netrics", with a silent \'m\'), is the netball performance app for live scores, player and team metrics, performance insights and leaderboards.'}
                        </p>
                        <p className='hero-subcopy'>All U14 & U16 National Clubs Finals sign-ups will receive these early access benefits.</p>
                      </>
                    )}
                  </div>

                  <div className='hero-benefits'>
                    {secTop?.subsections && secTop.subsections.length > 0 ? (
                      secTop.subsections.map((sub, index) => (
                        <span className='hero-benefit-chip' key={index}>
                          {sub.shortDescription}
                        </span>
                      ))
                    ) : chipsCMS ? (
                      (() => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(chipsCMS.description, 'text/html');
                        // Get text from paragraphs, list items, or just split by lines if it's plain text
                        let items = Array.from(doc.querySelectorAll('p, li')).map(el => el.textContent.trim()).filter(t => t !== '');

                        if (items.length === 0) {
                          // If no P or LI tags, try splitting by line breaks
                          items = chipsCMS.description.replace(/<[^>]*>/g, '\n').split('\n').map(t => t.trim()).filter(t => t !== '');
                        }

                        return items.map((text, index) => (
                          <span className='hero-benefit-chip' key={index}>
                            {text}
                          </span>
                        ));
                      })()
                    ) : (
                      <>
                        <span className='hero-benefit-chip'>
                          First season premium access
                        </span>
                        <span className='hero-benefit-chip'>
                          50% off future subscriptions
                        </span>
                        <span className='hero-benefit-chip'>
                          Founding team recognition
                        </span>
                      </>
                    )}
                  </div>

                  <div className='hero-store-badges'>
                    <span className='store-badge-label'>Download it here</span>
                    <div className='store-badges-group'>
                      <a
                        href={globalSettings?.app_store_link || 'https://apps.apple.com'}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='store-badge-wrapper'
                        aria-label='Download on the Apple App Store'
                      >
                        <img src={appStoreImg} alt='Download on the App Store' className='store-badge-img' />
                      </a>
                      <a
                        href={globalSettings?.play_store_link || 'https://play.google.com/store'}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='store-badge-wrapper'
                        aria-label='Get it on Google Play'
                      >
                        <img src={googlePlayImg} alt='Get it on Google Play' className='store-badge-img' />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-5'>
                <div className='founding-card'>
                  <div className='founding-card-head'>
                    <h3 className='founding-title'>Become a mNetrics Member</h3>
                    <p className='founding-text'>
                      Be among the first to use the mNetrics app for Coaches, Team Managers, Parents, and Players
                      across every level of the game.
                    </p>
                  </div>

                  <form className='founding-card-body' onSubmit={handleSubmit}>
                    <div className='form-group'>
                      <label className='form-label'>Name <span>*</span></label>
                      <input
                        type='text'
                        name='name'
                        className='form-control founding-input'
                        placeholder='Your full name'
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className='form-group'>
                      <label className='form-label '>Netball Profile <span>*</span></label>
                      <div className='profile-chips'>
                        {['Team Manager', 'Parent', 'Player', 'Coach'].map(p => (
                          <span
                            key={p}
                            className={`profile-chip ${formData.profile === p ? 'active' : ''}`}
                            onClick={() => handleProfileSelect(p)}
                          >
                            {p}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className='form-group'>
                      <label className='form-label'>Club Name <span>*</span></label>
                      <input
                        type='text'
                        name='clubName'
                        className='form-control founding-input'
                        placeholder='Enter club name'
                        value={formData.clubName}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className='form-group'>
                      <label className='form-label'>Email <span>*</span></label>
                      <input
                        type='email'
                        name='email'
                        className='form-control founding-input'
                        placeholder='you@example.com'
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>

                    <p className='recaptcha-branding'>
                      This site is protected by reCAPTCHA and the Google
                      <a href="https://policies.google.com/privacy"> Privacy Policy</a> and
                      <a href="https://policies.google.com/terms"> Terms of Service</a> apply.
                    </p>
                    <button type='submit' className='btn btn-primary mt-2'>
                      Join Early Access
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='see_mnetrics padding-bottom-100'>
          <div className='container'>

            <div className='mnetrics_head'>
              <div className='mnetrics-head-title-wrap d-flex flex-column gap-1'>
                <h2 className='mnetrics-head-title'>See mNetrics in action</h2>
                <p className='mnetrics-head-text'>Real-time data and insights to drive your team to success.</p>
              </div>
              <div className='mnetrics-head-text-wrap'>
                <div className='mnetrics-slider-arrows d-flex align-items-center gap-2'>
                  <button type='button' className='mnetrics-slider-arrow-btn' onClick={handlePrevSlide} aria-label='Previous slides'>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.5004 17.2246C12.342 17.2246 12.1837 17.1662 12.0587 17.0412L6.62539 11.6079C5.74206 10.7246 5.74206 9.27456 6.62539 8.39123L12.0587 2.95792C12.3004 2.71626 12.7004 2.71626 12.942 2.95792C13.1837 3.19959 13.1837 3.59959 12.942 3.84126L7.50872 9.27456C7.10872 9.67456 7.10872 10.3246 7.50872 10.7246L12.942 16.1579C13.1837 16.3996 13.1837 16.7996 12.942 17.0412C12.817 17.1579 12.6587 17.2246 12.5004 17.2246Z" fill="#001D3D" />
                    </svg>
                  </button>
                  <button type='button' className='mnetrics-slider-arrow-btn' onClick={handleNextSlide} aria-label='Next slides'>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.49963 17.2246C7.65797 17.2246 7.8163 17.1662 7.9413 17.0412L13.3746 11.6079C14.2579 10.7246 14.2579 9.27456 13.3746 8.39123L7.9413 2.95792C7.69963 2.71626 7.29963 2.71626 7.05797 2.95792C6.8163 3.19959 6.8163 3.59959 7.05797 3.84126L12.4913 9.27456C12.8913 9.67456 12.8913 10.3246 12.4913 10.7246L7.05797 16.1579C6.8163 16.3996 6.8163 16.7996 7.05797 17.0412C7.18297 17.1579 7.3413 17.2246 7.49963 17.2246Z" fill="#001D3D" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className='mnetrics_slider'>
              <div key={globalSettings ? 'loaded' : 'loading'} className='mnetrics-owl-slider owl-carousel'>
                {globalSettings?.home_videos && globalSettings?.home_videos?.length > 0 ? (
                  globalSettings.home_videos.map((vid, i) => (
                    <VideoCard
                      key={i}
                      type={vid.type || 'video'}
                      src={vid.url}
                      icon={vid.icon}
                      title={vid.title}
                      text={vid.text}
                    />
                  ))
                ) : (
                  <>
                    {/* <VideoCard 
                      type="video"
                      // src={v1} 
                      title="Live scores broadcasting" 
                      text="Follow matches live, even when you are not courtside." 
                    />
                    <VideoCard 
                      type="video"
                      // src={v2} 
                      title="Performance insights for coaches" 
                      text="Make smarter decisions with real match-day data." 
                    />
                    <VideoCard 
                      type="video"
                      // src={v3} 
                      title="Game day & historic team metrics" 
                      text="Game day & historic metrics for teams and players." 
                    /> */}
                  </>
                )}
              </div>
            </div>

            <div className='see-metrics-wrap'>
              <div className='audience-row'>
                {secMid?.subsections && secMid.subsections.length > 0 ? (
                  secMid.subsections.map((sub, index) => (
                    <article className='audience-card' key={index}>
                      <h3 className='audience-title'>{sub.shortDescription}</h3>
                      <p className='audience-text' style={{ whiteSpace: 'pre-line' }}>{sub.longDescription}</p>
                    </article>
                  ))
                ) : bottomCMS ? (
                  (() => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(bottomCMS.description, 'text/html');
                    const titles = Array.from(doc.querySelectorAll('h3')).map(h => h.textContent);
                    const texts = Array.from(doc.querySelectorAll('p')).map(p => p.textContent).filter(t => t.trim() !== '');

                    return titles.map((title, index) => (
                      <article className='audience-card' key={index}>
                        <h3 className='audience-title'>{title}</h3>
                        <p className='audience-text'>{texts[index] || ''}</p>
                      </article>
                    ));
                  })()
                ) : (
                  <>
                    <article className='audience-card'>
                      <h3 className='audience-title'>For Coaches</h3>
                      <p className='audience-text'>Live decisions powered by real performance data.</p>
                    </article>
                    <article className='audience-card'>
                      <h3 className='audience-title'>For Team Managers</h3>
                      <p className='audience-text'>Stronger visibility into team trends, metrics, and engagement.</p>
                    </article>
                    <article className='audience-card'>
                      <h3 className='audience-title'>For Parents & Players</h3>
                      <p className='audience-text'>Clearer insight into every match and season-long progress.</p>
                    </article>
                  </>
                )}
              </div>

              <div className='feature-grid'>
                {secBottom?.subsections && secBottom.subsections.length > 0 ? (
                  secBottom.subsections.map((sub, index) => {
                    return (
                      <article className='feature-card' key={index}>
                        <div className='feature-icon-wrap' aria-hidden='true'>
                          {sub.image ? (
                            <img src={sub.image} alt={sub.shortDescription} style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
                          ) : (
                            // Render fallback SVGs based on index
                            index === 0 ? (
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.777875 17.1112H3.88879C4.31827 17.1112 4.66667 17.4593 4.66667 17.8888V25.6667C4.66667 26.0962 4.31834 26.4446 3.88879 26.4446H0.777875C0.348396 26.4446 0 26.0963 0 25.6667V17.8888C0 17.4594 0.348323 17.1112 0.777875 17.1112ZM8.55546 10.8888H11.6667C12.0961 10.8888 12.4445 11.2372 12.4445 11.6667V25.6667C12.4445 26.0962 12.0962 26.4446 11.6667 26.4446H8.55546C8.12598 26.4446 7.77787 26.0963 7.77787 25.6667V11.6667C7.77787 11.2372 8.12591 10.8888 8.55546 10.8888ZM16.3333 14H19.4445C19.874 14 20.2221 14.3484 20.2221 14.7779V25.6667C20.2221 26.0962 19.8741 26.4446 19.4445 26.4446H16.3333C15.9039 26.4446 15.5555 26.0963 15.5555 25.6667V14.7779C15.5555 14.3484 15.9038 14 16.3333 14ZM24.1112 9.33337H27.2221C27.6516 9.33337 28 9.6817 28 10.1112V25.6667C28 26.0962 27.6517 26.4446 27.2221 26.4446H24.1112C23.6817 26.4446 23.3333 26.0963 23.3333 25.6667V10.1112C23.3333 9.68177 23.6817 9.33337 24.1112 9.33337Z" fill="white" />
                                <path d="M25.6667 0C24.3787 0.00145833 23.3348 1.04533 23.3333 2.33333C23.3365 2.58738 23.3815 2.83923 23.4666 3.07847L19.573 5.39292C19.3211 5.12575 19.0092 4.92238 18.6631 4.79963C18.317 4.67689 17.9467 4.63828 17.5827 4.68702C17.2188 4.73575 16.8717 4.87043 16.5701 5.0799C16.2684 5.28937 16.021 5.56763 15.8483 5.89167L12.4141 4.19074C12.4308 4.09077 12.4408 3.98993 12.4445 3.88879C12.4454 3.42698 12.3092 2.97529 12.0533 2.59092C11.7973 2.20655 11.433 1.90679 11.0065 1.72959C10.58 1.55239 10.1106 1.50573 9.65758 1.59552C9.20458 1.6853 8.7884 1.90749 8.46176 2.23395C8.13504 2.56033 7.91255 2.97636 7.82249 3.42931C7.73243 3.88226 7.77885 4.35176 7.95586 4.7783L3.50117 8.10287C3.14783 7.89234 2.74463 7.78014 2.33333 7.77788C1.04475 7.77788 0 8.82233 0 10.1112C0 11.3998 1.04475 12.4445 2.33333 12.4445C3.62192 12.4445 4.66667 11.3998 4.66667 10.1112C4.66468 9.83055 4.61168 9.5526 4.51026 9.2909L9.00951 5.93308C9.88961 6.42381 10.9874 6.27995 11.7111 5.57871L15.6164 7.51297C15.8767 8.67256 16.9679 9.45066 18.1491 9.31912C19.3304 9.1875 20.2236 8.18861 20.2221 7C20.2221 6.94072 20.209 6.88494 20.2048 6.82682L24.4396 4.30923C24.8069 4.5414 25.2322 4.66529 25.6667 4.66667C26.9552 4.66667 28 3.62192 28 2.33333C28 1.04475 26.9552 0 25.6667 0Z" fill="white" />
                              </svg>
                            ) : index === 1 ? (
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_13868_9583_custom)">
                                  <path d="M16.8968 6.26247C18.1914 7.0742 19.0993 8.44782 19.2645 10.0423C19.8074 10.2977 20.3999 10.4303 20.9998 10.4308C23.268 10.4308 25.1064 8.59248 25.1064 6.32467C25.1064 4.0565 23.268 2.21814 20.9998 2.21814C18.7533 2.21884 16.931 4.02435 16.8968 6.26247ZM14.2065 14.6705C16.4747 14.6705 18.313 12.8318 18.313 10.564C18.313 8.29616 16.4743 6.4578 14.2065 6.4578C11.9387 6.4578 10.0993 8.29651 10.0993 10.5643C10.0993 12.8321 11.9387 14.6705 14.2065 14.6705ZM15.9484 14.9504H12.4639C9.56466 14.9504 7.20599 17.3094 7.20599 20.2087V24.47V24.47H21.2053V20.2087C21.2063 17.3094 18.8477 14.9504 15.9484 14.9504ZM22.7424 10.7111H19.2848C19.2497 12.0462 18.6882 13.3133 17.7229 14.2362C20.2999 15.0025 22.1854 17.3922 22.1854 20.2149V21.5281C25.5994 21.403 27.5667 20.4354 27.6963 20.3704L27.9706 20.2314H28V15.9686C28 13.0698 25.6413 10.7111 22.7424 10.7111ZM7.00087 10.4315C7.80422 10.4315 8.55165 10.1971 9.18482 9.79767C9.38349 8.51262 10.0672 7.35261 11.0952 6.55634C11.0994 6.47947 11.1067 6.40329 11.1067 6.32572C11.1067 4.05755 9.26799 2.21919 7.00087 2.21919C4.73236 2.21919 2.89435 4.05755 2.89435 6.32572C2.89435 8.59283 4.73236 10.4315 7.00087 10.4315ZM10.6888 14.2362C9.72875 13.3177 9.16815 12.0587 9.12787 10.7307C8.99963 10.7212 8.87278 10.7111 8.74209 10.7111H5.25791C2.35867 10.7111 0 13.0698 0 15.9686V20.2307L0.0108324 20.2964L0.304355 20.389C2.52395 21.0819 4.50488 21.4013 6.22548 21.5019V20.2149C6.22618 17.3922 8.11102 15.0032 10.6888 14.2362Z" fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_13868_9583_custom">
                                    <rect width="28" height="28" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            ) : index === 2 ? (
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_13868_9594_custom)">
                                  <path d="M16.5456 0H11.512C10.8091 0 10.2393 0.569819 10.2393 1.27273V26.7273C10.2393 27.4302 10.8091 28 11.512 28H16.5456C17.2485 28 17.8183 27.4302 17.8183 26.7273V1.27273C17.8183 0.569819 17.2485 0 16.5456 0Z" fill="white" />
                                  <path d="M6.30636 7.63635H1.27273C0.569819 7.63635 0 8.20617 0 8.90908V26.7273C0 27.4302 0.569819 28 1.27273 28H6.30636C7.00927 28 7.57909 27.4302 7.57909 26.7273V8.90908C7.57909 8.20617 7.00927 7.63635 6.30636 7.63635Z" fill="white" />
                                  <path d="M26.7273 15.2727H21.6936C20.9907 15.2727 20.4209 15.8425 20.4209 16.5454V26.7273C20.4209 27.4302 20.9907 28 21.6936 28H26.7273C27.4302 28 28 27.4302 28 26.7273V16.5454C28 15.8425 27.4302 15.2727 26.7273 15.2727Z" fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_13868_9594_custom">
                                    <rect width="28" height="28" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            ) : (
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_13868_9607_custom)">
                                  <path d="M19.0461 1.71279V0.75647H8.95393V1.71279H6.17969V3.54728C6.17969 5.67014 7.90103 7.39799 10.0212 7.40959C10.6763 8.11407 11.5827 8.5811 12.5963 8.66735V12.1048H10.263V14.2825H17.737V12.1048H15.4036V8.66735C16.4173 8.58105 17.3236 8.11402 17.9787 7.40959C20.0989 7.39799 21.8203 5.67009 21.8203 3.54728V1.71279H19.0461ZM7.82031 3.54728V3.35342H8.95393V4.70015C8.95393 4.98496 8.98461 5.26267 9.04165 5.53069C8.3178 5.16395 7.82031 4.41271 7.82031 3.54728ZM20.1797 3.54728C20.1797 4.41277 19.6822 5.16395 18.9583 5.53069C19.0166 5.25768 19.046 4.97931 19.046 4.70015V3.35342H20.1797V3.54728ZM0 21.7486H7.14602V27.2437H0V21.7486ZM20.854 19.2384H28V27.2436H20.854V19.2384ZM8.78664 15.9233H19.2139V27.2436H8.78664V15.9233Z" fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_13868_9607_custom">
                                    <rect width="28" height="28" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            )
                          )}
                        </div>
                        <div className='feature-copy'>
                          <h3 className='feature-title'>{sub.shortDescription}</h3>
                          <p className='feature-text' style={{ whiteSpace: 'pre-line' }}>{sub.longDescription}</p>
                        </div>
                      </article>
                    );
                  })
                ) : featureCMS && featureCMS.images && featureCMS.images.length > 0 ? (
                  featureCMS.images.map((img, index) => {
                    // Extract titles and text from HTML description
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(featureCMS.description, 'text/html');
                    const titles = Array.from(doc.querySelectorAll('h3')).map(h => h.textContent);
                    const texts = Array.from(doc.querySelectorAll('p')).map(p => p.textContent).filter(t => t.trim() !== '');

                    return (
                      <article className='feature-card' key={index}>
                        <div className='feature-icon-wrap' aria-hidden='true'>
                          <img src={img} alt={titles[index] || `Feature ${index + 1}`} style={{}} />
                        </div>
                        <div className='feature-copy'>
                          <h3 className='feature-title'>{titles[index] || 'Feature Title'}</h3>
                          <p className='feature-text'>{texts[index] || 'Feature Description'}</p>
                        </div>
                      </article>
                    );
                  })
                ) : (
                  <>
                    <article className='feature-card'>
                      <div className='feature-icon-wrap' aria-hidden='true'>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.777875 17.1112H3.88879C4.31827 17.1112 4.66667 17.4593 4.66667 17.8888V25.6667C4.66667 26.0962 4.31834 26.4446 3.88879 26.4446H0.777875C0.348396 26.4446 0 26.0963 0 25.6667V17.8888C0 17.4594 0.348323 17.1112 0.777875 17.1112ZM8.55546 10.8888H11.6667C12.0961 10.8888 12.4445 11.2372 12.4445 11.6667V25.6667C12.4445 26.0962 12.0962 26.4446 11.6667 26.4446H8.55546C8.12598 26.4446 7.77787 26.0963 7.77787 25.6667V11.6667C7.77787 11.2372 8.12591 10.8888 8.55546 10.8888ZM16.3333 14H19.4445C19.874 14 20.2221 14.3484 20.2221 14.7779V25.6667C20.2221 26.0962 19.8741 26.4446 19.4445 26.4446H16.3333C15.9039 26.4446 15.5555 26.0963 15.5555 25.6667V14.7779C15.5555 14.3484 15.9038 14 16.3333 14ZM24.1112 9.33337H27.2221C27.6516 9.33337 28 9.6817 28 10.1112V25.6667C28 26.0962 27.6517 26.4446 27.2221 26.4446H24.1112C23.6817 26.4446 23.3333 26.0963 23.3333 25.6667V10.1112C23.3333 9.68177 23.6817 9.33337 24.1112 9.33337Z" fill="white" />
                          <path d="M25.6667 0C24.3787 0.00145833 23.3348 1.04533 23.3333 2.33333C23.3365 2.58738 23.3815 2.83923 23.4666 3.07847L19.573 5.39292C19.3211 5.12575 19.0092 4.92238 18.6631 4.79963C18.317 4.67689 17.9467 4.63828 17.5827 4.68702C17.2188 4.73575 16.8717 4.87043 16.5701 5.0799C16.2684 5.28937 16.021 5.56763 15.8483 5.89167L12.4141 4.19074C12.4308 4.09077 12.4408 3.98993 12.4445 3.88879C12.4454 3.42698 12.3092 2.97529 12.0533 2.59092C11.7973 2.20655 11.433 1.90679 11.0065 1.72959C10.58 1.55239 10.1106 1.50573 9.65758 1.59552C9.20458 1.6853 8.7884 1.90749 8.46176 2.23395C8.13504 2.56033 7.91255 2.97636 7.82249 3.42931C7.73243 3.88226 7.77885 4.35176 7.95586 4.7783L3.50117 8.10287C3.14783 7.89234 2.74463 7.78014 2.33333 7.77788C1.04475 7.77788 0 8.82233 0 10.1112C0 11.3998 1.04475 12.4445 2.33333 12.4445C3.62192 12.4445 4.66667 11.3998 4.66667 10.1112C4.66468 9.83055 4.61168 9.5526 4.51026 9.2909L9.00951 5.93308C9.88961 6.42381 10.9874 6.27995 11.7111 5.57871L15.6164 7.51297C15.8767 8.67256 16.9679 9.45066 18.1491 9.31912C19.3304 9.1875 20.2236 8.18861 20.2221 7C20.2221 6.94072 20.209 6.88494 20.2048 6.82682L24.4396 4.30923C24.8069 4.5414 25.2322 4.66529 25.6667 4.66667C26.9552 4.66667 28 3.62192 28 2.33333C28 1.04475 26.9552 0 25.6667 0Z" fill="white" />
                        </svg>
                      </div>
                      <div className='feature-copy'>
                        <h3 className='feature-title'>Live match data</h3>
                        <p className='feature-text'>Real-time scores and match events.</p>
                      </div>
                    </article>
                    <article className='feature-card'>
                      <div className='feature-icon-wrap' aria-hidden='true'>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_13868_9583)">
                            <path d="M16.8968 6.26247C18.1914 7.0742 19.0993 8.44782 19.2645 10.0423C19.8074 10.2977 20.3999 10.4303 20.9998 10.4308C23.268 10.4308 25.1064 8.59248 25.1064 6.32467C25.1064 4.0565 23.268 2.21814 20.9998 2.21814C18.7533 2.21884 16.931 4.02435 16.8968 6.26247ZM14.2065 14.6705C16.4747 14.6705 18.313 12.8318 18.313 10.564C18.313 8.29616 16.4743 6.4578 14.2065 6.4578C11.9387 6.4578 10.0993 8.29651 10.0993 10.5643C10.0993 12.8321 11.9387 14.6705 14.2065 14.6705ZM15.9484 14.9504H12.4639C9.56466 14.9504 7.20599 17.3094 7.20599 20.2087V24.47L7.21682 24.5367L7.51035 24.6286C10.2771 25.4931 12.6809 25.7814 14.6594 25.7814C18.5237 25.7814 20.7636 24.6796 20.9016 24.6094L21.1759 24.4707H21.2053V20.2087C21.2063 17.3094 18.8477 14.9504 15.9484 14.9504ZM22.7424 10.7111H19.2848C19.2497 12.0462 18.6882 13.3133 17.7229 14.2362C20.2999 15.0025 22.1854 17.3922 22.1854 20.2149V21.5281C25.5994 21.403 27.5667 20.4354 27.6963 20.3704L27.9706 20.2314H28V15.9686C28 13.0698 25.6413 10.7111 22.7424 10.7111ZM7.00087 10.4315C7.80422 10.4315 8.55165 10.1971 9.18482 9.79767C9.38349 8.51262 10.0672 7.35261 11.0952 6.55634C11.0994 6.47947 11.1067 6.40329 11.1067 6.32572C11.1067 4.05755 9.26799 2.21919 7.00087 2.21919C4.73236 2.21919 2.89435 4.05755 2.89435 6.32572C2.89435 8.59283 4.73236 10.4315 7.00087 10.4315ZM10.6888 14.2362C9.72875 13.3177 9.16815 12.0587 9.12787 10.7307C8.99963 10.7212 8.87278 10.7111 8.74209 10.7111H5.25791C2.35867 10.7111 0 13.0698 0 15.9686V20.2307L0.0108324 20.2964L0.304355 20.389C2.52395 21.0819 4.50488 21.4013 6.22548 21.5019V20.2149C6.22618 17.3922 8.11102 15.0032 10.6888 14.2362Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_13868_9583">
                              <rect width="28" height="28" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='feature-copy'>
                        <h3 className='feature-title'>Historic team trends</h3>
                        <p className='feature-text'>Track progress across the season.</p>
                      </div>
                    </article>
                    <article className='feature-card'>
                      <div className='feature-icon-wrap' aria-hidden='true'>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_13868_9594)">
                            <path d="M16.5456 0H11.512C10.8091 0 10.2393 0.569819 10.2393 1.27273V26.7273C10.2393 27.4302 10.8091 28 11.512 28H16.5456C17.2485 28 17.8183 27.4302 17.8183 26.7273V1.27273C17.8183 0.569819 17.2485 0 16.5456 0Z" fill="white" />
                            <path d="M6.30636 7.63635H1.27273C0.569819 7.63635 0 8.20617 0 8.90908V26.7273C0 27.4302 0.569819 28 1.27273 28H6.30636C7.00927 28 7.57909 27.4302 7.57909 26.7273V8.90908C7.57909 8.20617 7.00927 7.63635 6.30636 7.63635Z" fill="white" />
                            <path d="M26.7273 15.2727H21.6936C20.9907 15.2727 20.4209 15.8425 20.4209 16.5454V26.7273C20.4209 27.4302 20.9907 28 21.6936 28H26.7273C27.4302 28 28 27.4302 28 26.7273V16.5454C28 15.8425 27.4302 15.2727 26.7273 15.2727Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_13868_9594">
                              <rect width="28" height="28" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='feature-copy'>
                        <h3 className='feature-title'>Player insights</h3>
                        <p className='feature-text'>Game-day and historic player performance.</p>
                      </div>
                    </article>
                    <article className='feature-card'>
                      <div className='feature-icon-wrap' aria-hidden='true'>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_13868_9607)">
                            <path d="M19.0461 1.71279V0.75647H8.95393V1.71279H6.17969V3.54728C6.17969 5.67014 7.90103 7.39799 10.0212 7.40959C10.6763 8.11407 11.5827 8.5811 12.5963 8.66735V12.1048H10.263V14.2825H17.737V12.1048H15.4036V8.66735C16.4173 8.58105 17.3236 8.11402 17.9787 7.40959C20.0989 7.39799 21.8203 5.67009 21.8203 3.54728V1.71279H19.0461ZM7.82031 3.54728V3.35342H8.95393V4.70015C8.95393 4.98496 8.98461 5.26267 9.04165 5.53069C8.3178 5.16395 7.82031 4.41271 7.82031 3.54728ZM20.1797 3.54728C20.1797 4.41277 19.6822 5.16395 18.9583 5.53069C19.0166 5.25768 19.046 4.97931 19.046 4.70015V3.35342H20.1797V3.54728ZM0 21.7486H7.14602V27.2437H0V21.7486ZM20.854 19.2384H28V27.2436H20.854V19.2384ZM8.78664 15.9233H19.2139V27.2436H8.78664V15.9233Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_13868_9607">
                              <rect width="28" height="28" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='feature-copy'>
                        <h3 className='feature-title'>Player ranking</h3>
                        <p className='feature-text'>Leaderboards that add visibility and engagement.</p>
                      </div>
                    </article>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className='join_easy_section padding-top-100 padding-bottom-100'>
          <div className='container'>

            <div className='row align-items-center row-gap-md-5 row-gap-4 align-items-center'>
              <div className='col-lg-6'>
                <div className='join-easy-image-wrap d-flex flex-column align-items-center align-items-lg-start gap-4'>
                  <img src={joinEasyImage} alt='Join Easy img' className='join-easy-image img-fluid' />
                  <div className='join-easy-store-badges'>
                    <span className='store-badge-label'>Download it here</span>
                    <div className='store-badges-group'>
                      <a
                        href={globalSettings?.app_store_link || 'https://apps.apple.com'}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='store-badge-wrapper'
                        aria-label='Download on the Apple App Store'
                      >
                        <img src={appStoreImg} alt='Download on the App Store' className='store-badge-img' />
                      </a>
                      <a
                        href={globalSettings?.play_store_link || 'https://play.google.com/store'}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='store-badge-wrapper'
                        aria-label='Get it on Google Play'
                      >
                        <img src={googlePlayImg} alt='Get it on Google Play' className='store-badge-img' />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <form className='join-easy-form' onSubmit={handleSubmit}>
                  <h2 className='join-easy-title'>Join Early Access</h2>
                  <div className='form-group'>
                    <label className='form-label'>Name <span>*</span></label>
                    <input
                      type='text'
                      name='name'
                      className='form-control founding-input'
                      placeholder='Your full name'
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className='form-group'>
                    <label className='form-label '>Netball Profile <span>*</span></label>
                    <div className='profile-chips'>
                      {['Team Manager', 'Parent', 'Player', 'Coach'].map(p => (
                        <span
                          key={p}
                          className={`profile-chip ${formData.profile === p ? 'active' : ''}`}
                          onClick={() => handleProfileSelect(p)}
                        >
                          {p}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className='form-group'>
                    <label className='form-label'>Club Name <span>*</span></label>
                    <input
                      type='text'
                      name='clubName'
                      className='form-control founding-input'
                      placeholder='Enter club name'
                      value={formData.clubName}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className='form-group'>
                    <label className='form-label'>Email <span>*</span></label>
                    <input
                      type='email'
                      name='email'
                      className='form-control founding-input'
                      placeholder='you@example.com'
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>

                  <p className='recaptcha-branding'>
                    This site is protected by reCAPTCHA and the Google
                    <a href="https://policies.google.com/privacy"> Privacy Policy</a> and
                    <a href="https://policies.google.com/terms"> Terms of Service</a> apply.
                  </p>
                  <button type='submit' className='btn btn-primary mt-2'>
                    Join Early Access
                  </button>
                </form>
              </div>
            </div>

          </div>
        </section>

        <section className='home_faq padding-top-100'>
          <div className='container'>
            <div className='faq-wrap'>
              <h2 className='faq-title text-center'>Frequently Asked Questions</h2>

              <div className='faq-list'>
                {faqs.map((item, index) => {
                  const isOpen = activeFaqIndex === index

                  return (
                    <article className={`faq-item ${isOpen ? 'active' : ''}`} key={index}>
                      <button
                        type='button'
                        className='faq-question-row'
                        onClick={() => handleFaqToggle(index)}
                        aria-expanded={isOpen}
                      >
                        <span className='faq-question'>{item.question}</span>
                        <span className='faq-toggle-icon' aria-hidden='true'>
                          {isOpen ? '−' : '+'}
                        </span>
                      </button>

                      {isOpen && (
                        <div className='faq-answer-wrap'>
                          <p className='faq-answer'>{item.answer}</p>
                        </div>
                      )}
                    </article>
                  )
                })}
              </div>

              <div className='text-center mt-3'>
                <Link to='/faq' className='btn btn-secondary faq-view-all-btn'>
                  View All FAQs
                </Link>
              </div>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </React.Fragment>
  )
}

export default Home